module.exports = __webpack_public_path__ + "img/transition-5.e2d62da2.png";